module.exports = __webpack_public_path__ + "static/media/franchise-03.6874284a.png";